

const imageExtensions = ['gif', 'png', 'jpg', 'jpeg'];
const IsImage = (name: string) => {
    const extension = GetExtension(name);
    return imageExtensions.includes(extension ?? '');
}


const videoExtensions = ['mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'mp4'];
const IsVideo = (name: string) => {
    const extension = GetExtension(name);
    return videoExtensions.includes(extension ?? '');
}


const audioExtensions = ['aiff', 'au', 'mid', 'midi', 'mp3', 'm4a',  'mp4', 'wav', 'wma', 'flac', 'pcm'];
const IsAudio = (name: string) => {
    const extension = GetExtension(name);
    return audioExtensions.includes(extension ?? '');
}


const documentExtensions = ['pdf', 'csv', 'xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt'];
const IsDocument = (name: string) => {
    const extension = GetExtension(name);
    return documentExtensions.includes(extension ?? '');
}


const GetExtension = (name: string) => {
    return name.split('.').pop()?.split('?')[0] ?? '';
}


const CreateUrl = (file: File) => {
    return URL.createObjectURL(file);
}



const FileHelper = {
    IsImage,
    IsVideo,
    IsAudio,
    IsDocument,
    GetExtension,
    CreateUrl
}

export default FileHelper;


export {
    imageExtensions,
    videoExtensions,
    audioExtensions,
    documentExtensions
};